import React from 'react'
import Navbar3 from '../../Navbars/Navbar3'

const TMLOptimizer = () => {
  return (
    <>
    <Navbar3/>
    <div>TMLOptimizer</div>
    </>
  )
}

export default TMLOptimizer